import debug, { ERROR } from './debug';
export class Emitter {
    constructor() {
        this.eventToListenersMap = new Map();
        this.destinations = new Set();
    }
    emit(eventName, ...args) {
        const listeners = this.eventToListenersMap.get(eventName);
        if (listeners) {
            listeners.forEach(listener => {
                listener(eventName, ...args);
            });
        }
        this.destinations.forEach(destination => {
            destination.emit(eventName, ...args);
        });
    }
    off(eventName, listener) {
        return this.eventToListenersMap.has(eventName) && this.eventToListenersMap.get(eventName).delete(listener);
    }
    on(eventName, listener) {
        let listeners = this.eventToListenersMap.get(eventName);
        if (listeners) {
            listeners.add(listener);
        }
        else {
            listeners = new Set([listener]);
            this.eventToListenersMap.set(eventName, listeners);
        }
        return this.off.bind(this, eventName, listener);
    }
    once(eventName, listener) {
        const off = this.on(eventName, (eventName, ...args) => {
            off();
            listener(eventName, ...args);
        });
        return off;
    }
    pipeEvents(emitter) {
        this.destinations.add(emitter);
    }
    future(eventName) {
        return new Promise(resolve => {
            this.once(eventName, (...args) => {
                resolve(args);
            });
        });
    }
}
export class MultiWindowEmitter extends Emitter {
    emit(name, ...args) {
        super.emit(name, ...args);
        const eventName = this.createStorageName(name);
        localStorage.setItem(eventName, JSON.stringify(args));
        localStorage.removeItem(eventName);
    }
    on(name, listener) {
        const off = super.on(name, listener);
        const handler = ({ key, newValue }) => {
            if (!newValue || key !== this.createStorageName(name)) {
                return;
            }
            try {
                const args = JSON.parse(newValue);
                listener(name, args);
            }
            catch (error) {
                debug(error, ERROR);
            }
        };
        window.addEventListener('storage', handler);
        return () => {
            window.removeEventListener('storage', handler);
            return off();
        };
    }
    createStorageName(name) {
        return `mol.ads.cmp.event.${name}`;
    }
}
